'use client';

import { useCallback, useLayoutEffect, useRef, useState } from 'react';

/** True when the element's content overflows its box (ellipsis / line-clamp). */
export function useIsTruncated<T extends HTMLElement = HTMLElement>(watch?: unknown) {
  const ref = useRef<T>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkOverflow = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setIsTruncated(el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1);
  }, []);

  useLayoutEffect(() => {
    checkOverflow();
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);
    return () => observer.disconnect();
  }, [checkOverflow, watch]);

  return { ref, isTruncated };
}
